<template>
    <div class="faq-content">
        <div class="wrapper">
            <div class="title">
                <h3>实名认证常见问题汇总</h3>
                <p>了解以下须知，滴滴与您共建安全出行平台</p>
            </div>
            <ul class="faq-list">
                <li class="list-item">
                    <div class="question"><span class="icon">Q</span><span class="mgs">为什么要进行实名认证？</span></div>
                    <div class="answer"><span class="icon">A</span><span class="mgs">完成实名认证可更好地保障您的账号安全，与滴滴共建安全出行秩序。为了保证实名信息真实，需完成人脸认证。</span></div>
                </li>
                <li class="list-item">
                    <div class="question"><span class="icon">Q</span><span class="mgs">我的实名认证信息别人是否可以看见？</span></div>
                    <div class="answer"><span class="icon">A</span><span class="mgs">司机无法看到乘客的实名认证信息。除法律法规要求必须向乘客披露的信息外，乘客也无法看到司机其他实名认证信息。</span></div>
                </li>
                <li class="list-item">
                    <div class="question"><span class="icon">Q</span><span class="mgs">当前实名信息不是我的怎么办？</span></div>
                    <div class="answer"><span class="icon">A</span><span class="mgs">若实名信息有误，您可拨打客服电话进行申诉。</span></div>
                </li>
                <li class="list-item">
                    <div class="question"><span class="icon">Q</span><span class="mgs">为什么我提交实名认证总是不通过？</span></div>
                    <div class="answer"><span class="icon">A</span><span class="mgs">请确认填写信息无误并确保您的网络情况良好。</span></div>
                    <div class="rename-item" v-if="isReameShow">如果您在公安局改过名字，请<span @click="goRename">点击这里</span></div>
                </li>
                <li class="list-item" v-if="isReameShow">
                    <div class="question"><span class="icon">Q</span><span class="mgs">当前实名不是我的怎么办？</span></div>
                    <div class="answer"><span class="icon">A</span><span class="mgs">若当前实名非您本人请<em class="light" @click="goClearName">点击这里</em>进行实名申诉。</span></div>
                </li>
                <li class="list-item">
                    <div class="question"><span class="icon">Q</span><span class="mgs">为什么我的人脸识别总是不通过？</span></div>
                    <div class="answer"><span class="icon">A</span><span class="mgs">请检查您的网络情况并移步到光线良好的地方重试。</span></div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { setPageTitle } from '@didi/public-sdk'
import { urlObj } from '../config'
import { goClearNamePage } from '../config/state'

export default {
    data () {
        return {
            isReameShow: false
        }
    },
    computed: {
        ...mapGetters({
// eslint-disable-next-line indent
           verifyData: 'verifyData'
        })
    },
    mounted () {
        setPageTitle({
            title: '常见问题',
        })
        // reanmeApolloInfo(this)
        this.isReameShow = false
    },
    methods: {
        goRename () {
            let renameBiz = 'safecenter'
            const { lang } = window.GlobalSet.query
            location.href = `${urlObj.renamePage}?biz=${renameBiz}&lang=${lang || 'zh-CN'}`
        },
        goClearName () {
            goClearNamePage()
        }
    }
}
</script>
<style lang="scss">
@import '~common-css/mixins.scss';
body{
    width:100%;
    height: 100%;
    background: #f3f4f5;
    overflow-x: hidden;
}
.faq-content {
    padding: px2rem(20);
    box-sizing: border-box;
    height: 100%;
    .wrapper {
        box-shadow: 0 px2rem(2) px2rem(8) 0 rgba(0,0,0,0.08);
        border-radius: px2rem(4);
        background: #fff;
        .title {
            @include border-bottom-1px(#eee);
            h3 {
                font-family: PingFangSC-Medium;
                font-size: px2rem(40);
                color: #333333;
                font-weight: bold;
                padding: px2rem(25) px2rem(30) px2rem(16) px2rem(30);
            }
            p {
                font-family: PingFangSC-Regular;
                font-size: px2rem(28);
                color: #9B9B9B;
                padding: 0 px2rem(30) px2rem(25) px2rem(30);
            }
        }
        .faq-list {
            .list-item {
                position: relative;
                padding: px2rem(36) px2rem(30) px2rem(30);
                @include border-bottom-1px(#eee);
                &:last-child {
                    @include border-bottom-1px(#fff);
                }
                .question {
                    font-family: PingFangSC-Medium;
                    font-size: px2rem(28);
                    color: #333333;
                    span {
                        font-weight: bold;
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .icon {
                        position: absolute;
                        top: px2rem(36);
                        left: px2rem(30);
                        width: 10px;
                        height: 10px;
                    }
                    .mgs {
                        word-wrap: break-word;
                        margin-left: px2rem(30);
                    }
                }
                .answer {
                    font-family: PingFangSC-Regular;
                    font-size: px2rem(28);
                    color: #666666;
                    margin-top: px2rem(12);
                    span {
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .icon {
                        position: absolute;
                        top: px2rem(82);
                        left: px2rem(30);
                        width: 10px;
                        height: 10px;
                    }
                    .mgs {
                        word-wrap: break-word;
                        margin-left: px2rem(30);
                        line-height: 15px;
                    }
                    .light {
                        font-style: normal;
                        color: #FC9153;
                    }
                }
                .rename-item {
                    font-size: px2rem(28);
                    color: #666666;
                    margin-left: px2rem(30);
                    margin-top: px2rem(8);
                    span {
                        color: #FC9153
                    }
                }

            }
        }
    }
}
</style>
